import angular from 'angular';
import _ from 'lodash';
import template from './criteriaTagView.html';

const additionalOptionsSortingOrderByAbsValue = [2, 1, 3];
export class CriteriaTagWithExclude {
    tagLabel = '';

    newSelected;

    mainConfigOptions = [
        {
            value: 'optional',
            label: 'NORMAL',
        },
        {
            value: 'preferred',
            label: 'PREFERRED_PRIORITY_LABEL',
        },
        {
            value: 'mandatory',
            label: 'MANDATORY_MINUS',
        },
        {
            value: 'filter',
            label: 'MANDATORY',
        },
        {
            value: 'excluded',
            label: 'EXCLUDED',
        },
    ];

    /* @ngInject */
    constructor(TFTTagsService, $scope) {
        this.tftTagsService = TFTTagsService;
        this.$scope = $scope;
    }

    $onInit() {
        const isTagExcluded = _.chain(this).get('selectedTag.additional.uid', '').toNumber().value() < 0
        || _.get(this, 'selectedTag.additional.exclude');

        this.newSelected = _.cloneDeep(this.selectedTag);

        if (isTagExcluded) {
            this.newSelected.required = 'excluded';
        }

        this.$onChanges();
    }

    handleMainConfigOptionChange(value) {
        if (this.isLocationTag) {
            this.newSelected.required = value;
            if (value !== 'excluded') {
                _.set(this, 'newSelected.additional.exclude', false);
            }
        } else {
            let newAdditionalUid = Math.abs(_.toNumber(this.newSelected?.additional?.uid)) || 2;

            if (value === 'excluded') {
                newAdditionalUid = `-${newAdditionalUid}`;
            } else {
                newAdditionalUid = `${newAdditionalUid}`;
            }

            this.newSelected.additional.uid = newAdditionalUid;
        }
    }

    getTagLabel(tag) {
        const mainLabel = _.get(tag, 'text') || _.get(tag, 'value') || _.get(tag, 'uid');
        if (this.hideAdditional) {
            return mainLabel;
        }

        const additionalLabel = _.chain(this)
            .get('dynamicSubCriteriaData')
            .find({ id: tag?.additional?.uid })
            .get('text')
            .value();

        return [mainLabel, additionalLabel].filter(Boolean).join(', ');
    }

    getAdditionalOptions({ options, isTagExcluded, isLocationTag }) {
        return _.chain(options)
            .filter((o) => ((isTagExcluded && !isLocationTag) ? _.toNumber(o.id) < 0 : _.toNumber(o.id) > 0))
            .sortBy((o) => {
                const absValue = Math.abs(_.toNumber(o.id));

                return _.indexOf(additionalOptionsSortingOrderByAbsValue, absValue);
            })
            .value();
    }

    handleAdditionalOptionChange(uid) {
        _.set(this, 'newSelected.additional.uid', uid);
    }

    handleChangesCancel() {
        const isTagExcluded = _.chain(this).get('selectedTag.additional.uid', '').toNumber().value() < 0
        || _.get(this, 'selectedTag.additional.exclude');

        this.newSelected = _.cloneDeep(this.selectedTag);

        if (isTagExcluded) {
            this.newSelected.required = 'excluded';
        }

        this.$onChanges();
        this.closePopup();
    }

    $onChanges() {
        this.tagLabel = this.getTagLabel(this.newSelected);

        const isTagExcluded = _.chain(this).get('newSelected.additional.uid', '').toNumber().value() < 0
        || _.get(this, 'newSelected.additional.exclude');

        this.additionalValue = _.toString(this.newSelected?.additional?.uid);

        this.additionalOptions = this.getAdditionalOptions({
            options: this.dynamicSubCriteriaData,
            isTagExcluded,
            isLocationTag: this.isLocationTag,
        });

        const { className, styles } = this.tftTagsService.getTagStyles({
            priority: this.newSelected?.required,
            isExcluded: isTagExcluded,
        });

        const additionalClassName = this.selectedTag.status ? (`${this.selectedTag.status}Filter`) : '';

        this.styles = styles;
        this.className = `${className} ${additionalClassName}`;
    }
}

export const config = {
    template,
    bindings: {
        isLocationTag: '<',
        selectedTag: '<',
        selectedIndex: '<',
        popupViewIndex: '<',
        requiredIndexes: '<',
        disable: '<',
        setAsMandatory: '<',
        showSettingsPopup: '<',
        hasPreferred: '<',
        mandatoryValues: '<',
        dynamicSubCriteriaData: '<',
        cancelChanges: '&',
        removeValue: '&',
        saveChanges: '&',
        closePopup: '&',
        setPopupCriteriaIndex: '&',
        hideAdditional: '<',
    },
    controller: CriteriaTagWithExclude,
    controllerAs: 'ctrl',
};

angular.module('TALENYA-FE').component('criteriaTagWithExcludeOption', config);
